/* Squishy Life – interacciones de la landing (sin dependencias) */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function nextMidnight() { var d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime(); }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* Segundos que faltan para la medianoche en una zona horaria (Chile o México) */
  function secsToMidnight(tz) {
    try {
      var p = new Intl.DateTimeFormat('en-GB', { timeZone: tz, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).formatToParts(new Date());
      var g = function (k) { for (var i = 0; i < p.length; i++) if (p[i].type === k) return +p[i].value; return 0; };
      return 86400 - ((g('hour') % 24) * 3600 + g('minute') * 60 + g('second'));
    } catch (e) { return Math.round((nextMidnight() - Date.now()) / 1000); }
  }
  function todayIn(tz) {
    try { return new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()); }
    catch (e) { var d = new Date(); return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  }

  /* Texto de Black Friday: solo entre las fechas configuradas */
  function initAnnBF() {
    $$('[data-sl-ann-bf]').forEach(function (bar) {
      var r = bar.getAttribute('data-sl-ann-bf').split('|'), today = todayIn(bar.getAttribute('data-tz'));
      var on = r[0] && r[1] && today >= r[0] && today <= r[1];
      var def = $('[data-ann-default]', bar), bf = $('[data-ann-bf]', bar);
      if (def) def.hidden = !!on;
      if (bf) bf.hidden = !on;
    });
  }

  /* Contador de la barra promocional: cuenta hasta la fecha configurada */
  function initCountdowns() {
    $$('[data-sl-countdown]').forEach(function (el) {
      var attr = el.getAttribute('data-sl-countdown');
      var daily = attr === 'daily';
      var tz = el.getAttribute('data-tz');
      var midnight = function () { return tz ? Date.now() + secsToMidnight(tz) * 1000 : nextMidnight(); };
      var end = daily ? midnight() : Date.parse(attr);
      if (isNaN(end)) return;
      var d = $('[data-u="d"]', el), h = $('[data-u="h"]', el), m = $('[data-u="m"]', el), s = $('[data-u="s"]', el);
      function tick() {
        var diff = Math.max(0, end - Date.now());
        var sec = Math.floor(diff / 1000);
        var days = Math.floor(sec / 86400);
        if (d) d.textContent = pad(days);
        if (h) h.textContent = pad(Math.floor(sec % 86400 / 3600) + (d ? 0 : days * 24));
        if (m) m.textContent = pad(Math.floor(sec % 3600 / 60));
        if (s) s.textContent = pad(sec % 60);
        if (diff <= 0 && daily) { end = midnight(); initAnnBF(); setTimeout(tick, 1000); return; }
        if (diff <= 0) {
          var bar = el.closest('[data-sl-hide-on-end]');
          if (bar) bar.hidden = true;
          return;
        }
        setTimeout(tick, 1000 - (Date.now() % 1000));
      }
      tick();
    });
  }

  /* Menú móvil */
  function initDrawer() {
    var drawer = $('[data-sl-drawer]');
    if (!drawer) return;
    function open() { drawer.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; var f = $('a,button', $('.sl-drawer__panel', drawer)); if (f) f.focus(); }
    function close() { drawer.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
    $$('[data-sl-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { open(); b.setAttribute('aria-expanded', 'true'); }); });
    $$('[data-sl-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { close(); $$('[data-sl-drawer-open]').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); }); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* Galería de producto */
  function initGalleries() {
    $$('[data-sl-gallery]').forEach(function (gal) {
      var track = $('.sl-gal__track', gal);
      var slides = $$('.sl-gal__slide', gal);
      var thumbs = $$('.sl-gal__thumb', gal);
      if (!track || slides.length < 2) return;
      var i = 0;
      function go(n) {
        i = (n + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (-100 * i) + '%)';
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        var t = thumbs[i];
        if (t && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
          t.parentNode.scrollTo({ left: t.offsetLeft - t.parentNode.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
        }
        slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var prev = $('.sl-gal__nav--prev', gal), next = $('.sl-gal__nav--next', gal);
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
      var x0 = null, y0 = null;
      track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? i + 1 : i - 1);
        x0 = null;
      });
      go(0);
    });
  }

  /* Acordeones (producto y FAQ) */
  function initAccordions() {
    $$('.sl-acc__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.sl-acc__item');
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* Slider de reseñas */
  function initReviewSliders() {
    $$('[data-sl-reviews]').forEach(function (root) {
      var track = $('.sl-rev__track', root);
      var cards = $$('.sl-rev__card', root);
      var dotsWrap = $('.sl-rev__dots', root);
      var prev = $('.sl-rev__arrow--prev', root), next = $('.sl-rev__arrow--next', root);
      if (!track || !cards.length) return;
      var i = 0;
      function perView() { var w = window.innerWidth; return w < 750 ? 1 : (w < 990 ? 2 : 3); }
      function maxIndex() { return Math.max(0, cards.length - perView()); }
      function render() {
        var max = maxIndex();
        if (i > max) i = max;
        var step = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
        track.style.transform = 'translateX(' + (-step * i) + 'px)';
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i >= max;
        if (dotsWrap) {
          if (dotsWrap.children.length !== max + 1) {
            dotsWrap.innerHTML = '';
            for (var k = 0; k <= max; k++) {
              var b = document.createElement('button');
              b.type = 'button'; b.className = 'sl-rev__dot'; b.setAttribute('aria-label', 'Ir a la reseña ' + (k + 1));
              (function (n) { b.addEventListener('click', function () { i = n; render(); }); })(k);
              dotsWrap.appendChild(b);
            }
          }
          Array.prototype.forEach.call(dotsWrap.children, function (d, k) { d.classList.toggle('is-active', k === i); });
        }
      }
      if (prev) prev.addEventListener('click', function () { i = Math.max(0, i - 1); render(); });
      if (next) next.addEventListener('click', function () { i = Math.min(maxIndex(), i + 1); render(); });
      var x0 = null;
      track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { i = dx < 0 ? Math.min(maxIndex(), i + 1) : Math.max(0, i - 1); render(); }
        x0 = null;
      });
      window.addEventListener('resize', render);
      render();
    });
  }

  /* Cantidad */
  function initQty() {
    $$('[data-sl-qty]').forEach(function (box) {
      var input = $('input', box);
      $$('button', box).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v = b.getAttribute('data-step') === '-1' ? Math.max(1, v - 1) : v + 1;
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* Barra fija "Agregar al carrito": aparece cuando el botón principal sale de pantalla */
  function initSticky() {
    var sticky = $('[data-sl-sticky]');
    var mainBtn = $('[data-sl-main-atc]');
    if (!sticky || !mainBtn || !('IntersectionObserver' in window)) return;
    var footer = $('.sl-footer');
    var passed = false, footerVisible = false;
    function update() { sticky.classList.toggle('is-visible', passed && !footerVisible); }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { passed = !e.isIntersecting; });
      update();
    }).observe(mainBtn);
    if (footer) new IntersectionObserver(function (es) { footerVisible = es[0].isIntersecting; update(); }).observe(footer);
    var btn = $('button', sticky);
    if (btn) btn.addEventListener('click', function () {
      var form = mainBtn.closest('form');
      if (form && form.requestSubmit) form.requestSubmit(mainBtn); else mainBtn.click();
    });
  }

  /* Aparición suave al hacer scroll */
  function initReveal() {
    var els = $$('.sl-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Botón volver arriba */
  function initToTop() {
    var b = $('[data-sl-totop]');
    if (!b) return;
    var on = false;
    window.addEventListener('scroll', function () {
      var v = window.scrollY > 900;
      if (v !== on) { on = v; b.classList.toggle('is-visible', v); }
    }, { passive: true });
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* Ola animada: se pausa fuera de pantalla, reacciona al scroll y al puntero */
  function initWaves() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    $$('[data-sl-wave]').forEach(function (w) {
      if (w.dataset.slReady) return; w.dataset.slReady = '1';
      var layers = $$('.sl-wave__layer', w);
      var visible = false, ticking = false;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          visible = es[0].isIntersecting;
          w.classList.toggle('is-paused', !visible);
          if (visible) onScroll();
        }, { rootMargin: '100px 0px' }).observe(w);
      } else { visible = true; }
      function apply() {
        ticking = false;
        var y = window.scrollY || 0;
        layers.forEach(function (l) { l.style.setProperty('--sl-wave-shift', (-(y * 0.25 * parseFloat(l.dataset.depth || 1)) % 720) + 'px'); });
      }
      function onScroll() { if (reduce || !visible || ticking) return; ticking = true; requestAnimationFrame(apply); }
      window.addEventListener('scroll', onScroll, { passive: true });
      if (!reduce) {
        w.addEventListener('pointerenter', function () { w.classList.add('is-fast'); });
        w.addEventListener('pointerleave', function () { w.classList.remove('is-fast'); });
        w.addEventListener('touchstart', function () { w.classList.add('is-fast'); setTimeout(function () { w.classList.remove('is-fast'); }, 1500); }, { passive: true });
      }
    });
  }

  /* Fecha de envío según la zona horaria del mercado */
  function initShipDate() {
    var M = ['ene.', 'feb.', 'mar.', 'abr.', 'may.', 'jun.', 'jul.', 'ago.', 'sept.', 'oct.', 'nov.', 'dic.'];
    $$('[data-sl-ship]').forEach(function (row) {
      var el = $('[data-sl-today]', row);
      if (!el) return;
      function set() {
        try {
          var parts = new Intl.DateTimeFormat('en-US', { timeZone: row.getAttribute('data-tz') || 'America/Santiago', day: 'numeric', month: 'numeric' }).formatToParts(new Date());
          var d = 0, m = 0;
          parts.forEach(function (p) { if (p.type === 'day') d = +p.value; if (p.type === 'month') m = +p.value; });
          if (d && m) el.textContent = d + ' ' + M[m - 1];
        } catch (e) {}
      }
      set();
      setInterval(set, 60000);
    });
  }

  function init() {
    initAnnBF(); initCountdowns(); initDrawer(); initGalleries(); initAccordions();
    initReviewSliders(); initQty(); initSticky(); initReveal(); initToTop(); initWaves(); initShipDate();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
